import gql from "graphql-tag";
import styles from "./ArticleFoundationLine.module.scss";
import { ArticleFoundationLineFragment } from "types/api";

const ArticleFoundationLine = ({
  foundationLineArticle,
}: ArticleFoundationLineFragment) => {
  if (!foundationLineArticle) return null;
  return (
    <section className={styles.root}>
      <p
        className={styles.foundationLineText}
        dangerouslySetInnerHTML={{ __html: foundationLineArticle }}
      />
    </section>
  );
};

export default ArticleFoundationLine;

ArticleFoundationLine.fragment = gql`
  fragment articleFoundationLine on EditorialProject {
    foundationLineArticle
  }
`;
